import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'female-water-fasting': {
			// /water-fasting-f?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_water_fasting_models_from_creos~1
			landing: {
				experiment: () =>
					import(
						/* webpackChunkName: "landing" */ '@/modules/Landing/instances/experiments/web_water_fasting_models_from_creos'
					),
			},
			funnel: {
				id: 'ob-water-fasting-female-models-from-creos',
				locale: ['en'],
			},
		},
	},
]

export default config
